import React, { Component } from 'react';
import Moment from 'react-moment';
import moment from 'moment-timezone';
import _ from 'lodash';
import styles, { Container, Inner, ContainerTag, Row, Col, ProgressBar, Panel, Failer, Ribbon, Text, SmallText, DayText, TimeZoneText, MoreLink, ETA } from './styles';
import AxlTags from '../AxlTags';
import TimeWithTimezone from 'components/TimeWithTimezone';
import { TIME_ONLY_FORMAT } from 'constants/date';
import { Box } from '@mui/material';

const REGION_NAME = {
  sf: 'San Francisco',
  oc: 'Orange County',
  phx: 'Phoenix'
};

function regionName(code) {
  if (!code || code.length < 1) return '';
  const zones = code.split(',')
    .map(z => REGION_NAME[z] ? REGION_NAME[z] : z.replace('_', ' ').replace('-', ' / '));
  return zones.join(', ');
}

export class ZoneList extends Component {
  constructor(props) {
    super(props);
    this.state = { openMore: false };
  }

  render() {
    const { items } = this.props;
    const zonesArray = items ? items.split(', ') : [];
    return (
      <div>
        {!this.state.openMore && zonesArray[0]}
        {zonesArray.length > 1 && (
          <span>
            {this.state.openMore ? zonesArray.join(' / ') : <MoreLink onClick={() => this.setState({ openMore: true })}>{` +1 more`}</MoreLink>}
          </span>
        )}
      </div>
    );
  }
}

class ShowETA extends Component {
  constructor(props) {
    super(props);
    const { eta } = this.props;
    const e = moment(eta);
    this.state = {
      late: e.isBefore(moment.now()),
      veryLate: e.isBefore(moment().add(-30, 'minutes')),
    };
    this.refresh = this.refresh.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.eta !== this.props.eta) {
      this.refresh();
    }
  }

  refresh() {
    const { eta } = this.props;
    const e = moment(eta);
    if (this.state.veryLate) {
      if (!e.isBefore(moment().add(-30, 'minutes')))
        this.setState({ veryLate: false });
    } else if (e.isBefore(moment().add(-30, 'minutes')))
      this.setState({ veryLate: true });

    if (this.state.late) {
      if (!e.isBefore(moment()))
        this.setState({ late: false });
    } else if (e.isBefore(moment()))
      this.setState({ late: true });
  }

  componentDidMount() {
    this.refresh();
    this.interval = setInterval(this.refresh, 30000);
  }

  componentWillUnmount() {
    if (this.interval) clearInterval(this.interval);
  }

  render() {
    const { eta } = this.props;
    const color = this.state.veryLate ? "#f22" : this.state.late ? "#c84" : "#666";
    return (
      <Text>
        <ETA style={{ backgroundColor: color }}>
          <span style={{ fontSize: '0.9em', color: '#eee' }}>ETA</span> <Moment format={'hh:mma'}>{eta}</Moment>
        </ETA>
      </Text>
    );
  }
}

class JMiniAssignmentBox extends Component {
  render() {
    const { assignment, eta } = this.props;
    let dropoffStatusArray = [];
    if (assignment.extra?.dropoff_status) {
      dropoffStatusArray = _.split(assignment.extra.dropoff_status, '|').filter(s => s && s[0] === 'D');
    }

    if (assignment.minified)
      return <Container onClick={() => this.props.onClick && this.props.onClick()} style={{ ...this.props.style }} />;

    const driver = assignment.driver ? `${assignment.driver.first_name} ${assignment.driver.last_name}` : '-';
    const label = assignment.label ? (assignment.label.prefix ? assignment.label.prefix : assignment.label) : '-';
    const zones = assignment.zones ? regionName(assignment.zones) : regionName(assignment.region_code);
    const counter = assignment.shipment_count ? assignment.shipment_count : '-';
    const failureCounter = assignment.failed ? assignment.failed : 0;
    const completedCounter = assignment.extra?.dropoff_status 
      ? assignment.extra.dropoff_status.split('|').filter(a => a === 'DF' || a === 'DS' || a === 'DL' || a === 'DE').length 
      : '-';
    const status = this.props.status ? this.props.status.replace(' ', '_') : 'UNASSIGNED';
    const cardStyles = this.props.cardStyles || {};

    const localTimezone = moment.tz.guess();
    const defaultTimezone = _.has(assignment, 'timezone') && !_.isEmpty(_.get(assignment, 'timezone')) ? _.get(assignment, 'timezone') : 'America/Los_Angeles';
    const isSameTimezone = moment.tz(defaultTimezone).utcOffset() === moment.tz(localTimezone).utcOffset();

    let isRolled = false;
    if (assignment && _.has(assignment, 'predicted_start_ts') && _.has(assignment, 'predicted_latest_start_ts')) {
      const startDate = moment.tz(assignment.predicted_start_ts, defaultTimezone).format('YYYY-MM-DD');
      if (!!assignment.original_date && assignment.original_date !== startDate) {
        isRolled = true;
      }
    }

    return (
      <Container onClick={() => this.props.onClick && this.props.onClick()} style={{ ...this.props.style }}>
        {isRolled && <Ribbon>ROLLED</Ribbon>}
        <Inner style={{ backgroundColor: cardStyles.backgroundColor, color: cardStyles.color }}>
          <ProgressBar style={{ ...styles.statuses[status] }}>
            {dropoffStatusArray.map((e, i) => <Panel style={{ ...styles.PanelStatus[e] }} key={`panel-${i}`} />)}
          </ProgressBar>
          <Row style={{ marginBottom: "4px" }}>
            <Col style={{ flex: 0.6 }}>
              <Box as="div" style={{ display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' }}>
                <Text>{label}</Text>
                {assignment.isPickedUp && assignment.delivery_by_date_time && (
                  <TimeWithTimezone
                    variant="tooltip"
                    textFormat={TIME_ONLY_FORMAT}
                    timeTs={assignment.delivery_by_date_time}
                    timezone={assignment.timezone}
                    renderTooltip={(localTime) => `Driver OTD: ${localTime?.text} ${localTime?.zone}`}
                  />
                )}
              </Box>
            </Col>
            <Col style={{ flex: 0.4 }}>
              <Text className={`text-right`}><ZoneList items={zones} /></Text>
            </Col>
          </Row>
          <Row>
            <Col style={{ flex: 2 }}><Text>{driver}</Text></Col>
            {eta && <Col style={{ width: 90 }}><ShowETA eta={eta.eta} /></Col>}
            <Col style={{ width: 60 }}>
              <Row>
                <Col>{(failureCounter > 0) && <Text className={`text-right`}><Failer>{failureCounter}</Failer></Text>}</Col>
                <Col><Text className={`text-right`}>{completedCounter}/{counter}</Text></Col>
              </Row>
            </Col>
          </Row>
        </Inner>
        {this.props.tags && (
          <ContainerTag>
            <AxlTags isShowLabel={this.props.isShowLabelTag} tags={this.props.tags} message={this.props.message} />
          </ContainerTag>
        )}
      </Container>
    );
  }
}

export default JMiniAssignmentBox;

